import React, { useEffect, useState } from 'react';
import PageContainer from '../../components/PageContainer';
import MainContent from '../../components/MainContent';
import PageTitle from '../../components/Common/PageTitle/PageTitle';
import { useAccounts } from '../../DataStore/AccountsContext';
import ActivityLoader from '../../components/Common/ActivityLoader';
import Notification from '../../components/Common/Notification';
import ActionDropdownItem from '../../components/Common/PageTitle/ActionDropdownItem';
import { useTheme } from '../../DataStore/ThemeContext';
import AlertNotification from '../../components/Common/AlertNotification';
import ConfirmationDialog from '../../components/Common/ConfirmationDialog';
import ajaxAccountChart from '../../util/remote/ajaxAccountChart';

const AccountsChartTabularPage = () => {
    const { getAllAccounts, accountsCatalogue} = useAccounts();
    const { openSettings, setNotify } = useTheme();
    const [searchQuery, setSearchQuery] = useState(''); // Search input state
    const [selected, setSelected] = useState(null);
    const [showDelete, setShowDelete] = useState(false);

    useEffect(() => {
        getAllAccounts();
    }, []);


    const filteredAccounts = Array.isArray(accountsCatalogue)
    ? accountsCatalogue.filter(
          (account) =>
              account.account_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
              account.account_number?.toLowerCase().includes(searchQuery.toLowerCase())
            )
    : [];

    const handleEdit = () => {
        if (!selected) {
            setNotify(<Notification message="No account selected. Please make selection then try again." iconClass="fa fa-info" />);
            return;
        }
        openSettings('Edit Account', 'EditAccount', selected, "Save Account Changes");
    };

    const handleDelete = () => {
        if (!selected) {
            setNotify(<AlertNotification message="No account selected. Please make selection then try again." iconClass="fa fa-info" />);
            return;
        }
        setShowDelete(true);
    };

    const handleReposition = () => {
        if (!selected) {
            setNotify(<AlertNotification message="No account selected. Please make selection then try again." iconClass="fa fa-info" />);
            return;
        }
        openSettings('Change Account Hierarchy', 'RepositionAccount', selected);
    };

    const confirmDelete = async () => {
        setShowDelete(false);
        setNotify(<AlertNotification message="Deleting account..." loader={true} />);
        const response = await ajaxAccountChart.deleteAccount(selected.account_id);
        if (response.status === 'success') {
            setNotify(<Notification message={response.message} type="success" closable={false}/>);
            getAllAccounts(true);
        }else{
            setNotify(<Notification message={response.message} type="danger" closable={false}/>);
        }
    };

    const PageActions = () => (
        <>
            <ActionDropdownItem
                iconClass="fa fa-edit text-primary"
                label="Edit Account"
                onClick={handleEdit}
            />
            <ActionDropdownItem iconClass="fa-solid fa-sitemap text-secondary" label="Change Hierarchy" onClick={handleReposition} />
            <ActionDropdownItem iconClass="fa fa-sync text-success" label="Refresh" onClick={()=>getAllAccounts(true)} />
            <ActionDropdownItem iconClass="fa fa-trash-alt" label="Delete Account" onClick={handleDelete} className="text-danger" />
        </>
    );


    return (
        <>
            <PageContainer>
                <MainContent>
                    <PageTitle
                        title="Chart of Accounts"
                        description="List of all organisation accounts accordingly to account name"
                        iconClass="fa fa-project-diagram"
                        sticky={true}
                        PageActions={PageActions}
                    />

                    <div className="card mb-3">
                       
                        <div className="card-body">
                        <div className="mb-4">
                             <div className="search-container">
                                <i className="fa fa-filter search-icon"></i>
                                <input
                                    type="text"
                                    className="form-control search-input"
                                    placeholder="Search by account number or account title..."
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                />
                            </div>
                        </div>


                    {Array.isArray(filteredAccounts) && 
              <div className="table-responsive overflow-auto" style={{maxHeight: '65vh'}}>
                <table className="table table-hover table-striped table-bordere">
                  <thead>
                    <tr>
                      <th className="nowrap">Account Number</th>
                      <th className="nowrap">Account Type</th>
                      <th>Account Name</th>
                      <th>Description</th>
                      <th className='text-center' style={{width: '100px'}}>Main</th>
                    
                    </tr>
                  </thead>
                  <tbody>
                    {filteredAccounts.map((account, index) => (
                      <tr
                        key={index}
                        className={`link ${
                            account.account_id ===
                          selected?.account_id
                            ? "selected-row"
                            : ""
                        }`}
                        onClick={() => setSelected(account)}
                      >
                        <td>{account.account_number}</td>
                        <td>{account.account_type}</td>
                        <td>{account.account_name}</td>
                        <td>{account.description}</td>
                        <td className='text-center'>{account.is_sub_account_of*1 > 0 ? "No": "Yes"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            }

            {filteredAccounts.length === 0 &&
              <Notification
                type="info"
                message="No account found"
                closable={false}
              />}
            {!accountsCatalogue && <ActivityLoader width={20} />}


                       
                        </div>
                    </div>
                </MainContent>
            </PageContainer>
           {selected && <ConfirmationDialog
                title="Delete Account"
                alertDescription={`Are you sure you want to delete this account, ${selected.account_name} ?`}
                notes="If an account has transactions, it cannot be deleted."
                buttonLabel="Delete Account"
                show={showDelete}
                handleClose={() => setShowDelete(false)}
                handleConfirm={confirmDelete}
           />}
        </>
    );
};

export default AccountsChartTabularPage;
